import { QueryHookOptions } from '@apollo/client';
import { useUserRoles } from '@anytag/auth';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, useAllTalentAgenciesOrPartnersQuery } from '@anytag/graphql';

export const useAllTalentAgencyOrPartnerOptions = (options?: QueryHookOptions<Query>) => {
  const { isAdminStaffPartner } = useUserRoles();
  const { data, loading } = useAllTalentAgenciesOrPartnersQuery({
    fetchPolicy: 'cache-first',
    skip: !isAdminStaffPartner,
    ...options
  });
  const allTalentAgenciesPartners = data?.allTalentAgenciesPartners || [];

  return {
    loading,
    allTalentAgenciesPartners,
    allTalentAgencyPartnerOptions: getSelectOptions(allTalentAgenciesPartners)
  };
};
